import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// ✅ AG Grid 모듈 등록 (33.x 최신 방식)
// import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';

// ModuleRegistry.registerModules([AllCommunityModule]);


createApp(App)
  .use(router)
  .mount('#app');
